import Button from "@/components/bricks/button/Button";
import ChevronLeftIcon from "@/components/icons/ChevronLeftIcon";
import ChevronRightIcon from "@/components/icons/ChevronRightIcon";

import type { MockPagination } from "./types";

/**
 * Pilene slås fra hvis der ikke er nogen handler at kalde. Ellers ser de klikbare ud og gør
 * ingenting - det var netop fejlen da tabellerne ikke videresendte deres sideskift-handlere.
 */
interface DocumentPaginationControlsProps {
  pagination: MockPagination;
  showPagination?: boolean;
  onPreviousClick?: () => void;
  onNextClick?: () => void;
}

export const DocumentPaginationControls = ({
  pagination,
  showPagination = true,
  onPreviousClick,
  onNextClick,
}: DocumentPaginationControlsProps) => {
  if (!showPagination) return null;
  const firstRow = (pagination.page - 1) * pagination.pageSize + 1;
  const lastRow = Math.min(
    pagination.page * pagination.pageSize,
    pagination.totalCount,
  );

  return (
    <div className="c-pagination">
      <div className="c-pagination__text">
        {firstRow} - {lastRow}
        <span className="text-muted"> af {pagination.totalCount}</span>
      </div>
      <div className="c-pagination__links">
        <Button
          color="secondary"
          icon
          transparent
          disabled={!pagination.hasPreviousPage || !onPreviousClick}
          aria-label="Forrige dokumenter"
          onClick={() => onPreviousClick?.()}
        >
          <ChevronLeftIcon />
        </Button>
        <Button
          color="secondary"
          icon
          transparent
          disabled={!pagination.hasNextPage || !onNextClick}
          aria-label="Næste dokumenter"
          onClick={() => onNextClick?.()}
        >
          <ChevronRightIcon />
        </Button>
      </div>
    </div>
  );
};
